
// 校验是否微信浏览器打开
export function isWeiXin () {
  var ua = window.navigator.userAgent.toLowerCase()
  ua.match(/MicroMessenger/i) ? ua = ua.match(/MicroMessenger/i).toString() : ua = ua.match(/MicroMessenger/i)
  if (ua === 'micromessenger') {
    return true // 是微信端
  } else {
    return false
  }
}

// 获取url上参数
export function getUrlKey (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || ['', ''])[1].replace(/\+/g, '%20')) || null
}

// 获取url
export function getUri () {
  let uri = location.href
  return uri
}



// WEBPACK FOOTER //
// ./src/utils/getWx.js